import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EarlyInterventionSystemList from './List';
import Details from './Details';
import CreateRule from './New';
import RuleConfiguration from './Configuration';

export default function EarlyInterventionSystem() {
  return (
    <Routes>
      <Route
        index
        element={<EarlyInterventionSystemList />}
      />
      <Route
        path='new'
        element={<CreateRule />}
      />
      <Route
        path='configuration/:id'
        element={<RuleConfiguration />}
      />
      <Route
        path='details/:id/*'
        element={<Details />}
      />
      <Route
        path='*'
        element={
          <Navigate
            to='/admin/performance-reporting/early-intervention-system'
            replace
          />
        }
      />
    </Routes>
  );
}

